import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';

// 페이지 컴포넌트 import
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import ClassRoom from './pages/ClassRoom';
import ConsultationRoom from './pages/ConsultationRoom';
import Profile from './pages/Profile';
import ClassRecord from './pages/ClassRecord';
import AdminPage from './pages/AdminPage';
import AdminClasses from './pages/admin/AdminClasses';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';

function App() {
    return (
        <AuthProvider>
            <Router>
                <div className="app-container">
                    <Routes>
                        <Route path="/login" element={<Login />} />
                        <Route
                            path="/dashboard"
                            element={
                                <PrivateRoute>
                                    <Dashboard />
                                </PrivateRoute>
                            }
                        />
                        <Route path="/class/:classId" element={<ClassRoom />} />
                        <Route
                            path="/consultation/:classId"
                            element={
                                <PrivateRoute>
                                    <ConsultationRoom />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/class/record/:classId"
                            element={
                                <PrivateRoute>
                                    <ClassRecord />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/profile"
                            element={
                                <PrivateRoute>
                                    <Profile />
                                </PrivateRoute>
                            }
                        />
                        {/* Admin Routes */}
                        <Route
                            path="/admin"
                            element={
                                <PrivateRoute>
                                    <AdminPage />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/admin/classes"
                            element={
                                <PrivateRoute>
                                    <AdminClasses />
                                </PrivateRoute>
                            }
                        />
                        <Route path="/" element={<Navigate to="/login" replace />} />
                    </Routes>
                </div>
            </Router>
        </AuthProvider>
    );
}

export default App;
